import script from "./CarComparisonBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CarComparisonBar.vue?vue&type=script&setup=true&lang=js"

import "./CarComparisonBar.vue?vue&type=style&index=0&id=fa00e0cc&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa00e0cc"]])

export default __exports__